import classnames from 'classnames';
import { useState } from 'react';
import styles from './useModalFade.module.scss';
export function useModalFade(options) {
    var _a;
    const animationTime = (_a = options.animationTime) !== null && _a !== void 0 ? _a : 200;
    const [isClosing, setIsClosing] = useState(false);
    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            options.onClose();
        }, animationTime);
    };
    const vars = { '--animation-time': `${animationTime}ms` };
    return [
        handleClose,
        {
            style: vars,
            className: classnames({
                [styles.fadeIn]: !isClosing,
                [styles.fadeOut]: isClosing,
            }),
        },
    ];
}
